import type { FirebaseApp, FirebaseOptions } from 'firebase/app';
import { initializeApp } from 'firebase/app';
import { browserLocalPersistence, connectAuthEmulator, initializeAuth } from 'firebase/auth';
import { connectDatabaseEmulator, getDatabase } from 'firebase/database';
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';

import { getFirebaseConfig, getRuntimeFlags } from './env';

const emulatorHost = '127.0.0.1';

/**
 * Firebase app initialized for the selected MeshOS environment.
 */
export const app: FirebaseApp = initializeApp(getFirebaseConfig() as FirebaseOptions);

/**
 * Firebase Auth service. Uses localStorage because IndexedDB can be unavailable
 * in restricted browser contexts.
 */
export const auth = initializeAuth(app, {
  persistence: browserLocalPersistence,
});

/**
 * Firebase Realtime Database service.
 */
export const db = getDatabase(app);

/**
 * Firebase Functions service.
 */
export const functions = getFunctions(app);

/**
 * Firebase Storage service.
 */
export const storage = getStorage(app);

if (getRuntimeFlags().emulator) {
  connectAuthEmulator(auth, `http://${emulatorHost}:9099`);
  connectDatabaseEmulator(db, emulatorHost, 9000);
  connectFunctionsEmulator(functions, emulatorHost, 5111);
}

export default app;
